/**
* Book Reviews Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Book Reviews Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'book-reviews-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.js-content-slider-container' ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        dots: true,
        infinite: true,
        autoplaySpeed: 7000,
        mobileFirst: true,
        appendArrows: $( '.arrows-container' ),
        prevArrow: '<button type="button" class="slick-prev text-xl p-6"><svg class="icon icon-right-chevron-blue text-brand-blue button-fake-left"><use xlink:href="#icon-right-chevron-blue"></use></svg></button>',
        nextArrow: '<button type="button" class="slick-next text-xl p-6"><svg class="icon icon-right-chevron-blue text-brand-blue"><use xlink:href="#icon-right-chevron-blue"></use></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'book-reviews-slider', COMPONENT );
} )( app );
